/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from "react";
import {
  Table,
  Modal,
  Button,
  Dropdown,
} from "react-bootstrap";

import React, { useEffect, Fragment, useRef } from "react";
import ReactPaginate from "react-paginate";
import { useTranslate } from "../hooks/LanguageProvider";
import { Link, useNavigate } from "react-router-dom";
import { PropagateLoader } from "react-spinners";
import { Bounce, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ExcelJS from "exceljs";
import axios from "axios";
import { useAuth } from "../context/AuthContext";
import {
  addHiddenColumn,
  getHiddenColumns,
  removeHiddenColumn,
} from "../utilities/functions";
import "../App.css";

const backendUrl = process.env.REACT_APP_BACKEND_URL;

interface DeletedUser {
  id_user: number;
  name: string;
}

interface User {
  id_user: number;
  id_role: number;
  draft: number | null;
  nom_user: string;
  prenom_user: string;
  username_user: string;
  email_user: string;
  phone_user: string;
  wilaya: string;
  company: string;
  date_creation_user: string;
  role_name: string;
}

export function Users() {
  const PAGE_ID = 15;
  const currentPageRef = useRef(1);
  const { translate } = useTranslate();
  const [list_user, setListUser] = useState<User[]>([]);
  const [total, setTotal] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [limit, setLimit] = useState(10);
  const user_id =
    localStorage.getItem("userid") || localStorage.getItem("user_id");
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selecteduser_id, setSelecteduser_id] = useState<string | null>(null);
  const [showDeletedUsersModal, setShowDeletedUsersModal] = useState(false);
  const [deletedUsers, setDeletedUsers] = useState<DeletedUser[]>([]);
  const [deletedUsersCount, setDeletedUsersCount] = useState<number>(0);
  const [sortType, setSortType] = useState("id_user");
  const [sortDirection, setSortDirection] = useState<"asc" | "desc">("asc");
  const [list, setList] = useState<User[]>([]);
  const navigate = useNavigate();
  const [selectedUsers, setSelectedUsers] = useState<number[]>([]);
  const [selectAll, setSelectAll] = useState(false);
  const [showHardDeleteModal, setShowHardDeleteModal] = useState(false);
  const [hardDeleteUserId, setHardDeleteUserId] = useState<number | null>(null);
  const [userToActivate, setUserToActivate] = useState<User | null>(null);
  const [activatingUser, setActivatingUser] = useState(false);
  const { login } = useAuth();
  const [search, setSearch] = useState("");
  const [type, setType] = useState(1);
  const [typeSearch, setTypeSearch] = useState("username");
  const [selectedSearch, setSelectedSearch] = useState("username");
  const id_user_number = Number(user_id ?? 0);
  const columnsStorageKey = `users-hidden-columns-${id_user_number}`;

  const [selectedColumns, setSelectedColumns] = useState({
    id_user: true,
    name: true,
    username_user: true,
    company: true,
    email_user: true,
    phone_user: true,
    wilaya: true,
    date_creation_user: true,
    role_name: true,
  });

  const searchOptions = [
    { key: "id", type: 0 },
    { key: "username", type: 1 },
    { key: "email", type: 2 },
    { key: "phone", type: 3 },
    { key: "role", type: 4 },
    { key: "details", type: 5 },
  ];

  useEffect(() => {
    (async () => {
      if (!id_user_number) return;
      try {
        const hidden = await getHiddenColumns(id_user_number, PAGE_ID);
        setSelectedColumns((prev: any) => {
          const next = { ...prev };
          hidden.forEach((key: string) => {
            if (key in next) next[key] = false;
          });
          return next;
        });
      } catch (error) {
        console.error("Error loading user columns preferences:", error);
        const storedHidden = JSON.parse(
          localStorage.getItem(columnsStorageKey) || "[]",
        );

        if (Array.isArray(storedHidden)) {
          setSelectedColumns((prev: any) => {
            const next = { ...prev };
            storedHidden.forEach((key: string) => {
              if (key in next) next[key] = false;
            });
            return next;
          });
        }
      }
    })();
  }, [id_user_number, columnsStorageKey]);

  const handleColumnChange = async (column: string) => {
    if (!id_user_number) return;

    const currentlyVisible = !!(selectedColumns as any)[column];
    const nextVisible = !currentlyVisible;

    setSelectedColumns((prev: any) => ({ ...prev, [column]: nextVisible }));

    try {
      if (!nextVisible) {
        await addHiddenColumn({
          id_user: id_user_number,
          id_page: PAGE_ID,
          column_name: column,
        });
      } else {
        await removeHiddenColumn({
          id_user: id_user_number,
          id_page: PAGE_ID,
          column_name: column,
        });
      }

      const hiddenColumns = Object.entries({
        ...selectedColumns,
        [column]: nextVisible,
      })
        .filter(([, visible]) => !visible)
        .map(([key]) => key);
      localStorage.setItem(columnsStorageKey, JSON.stringify(hiddenColumns));
    } catch (error) {
      console.error("Error saving user columns preferences:", error);
      const hiddenColumns = Object.entries({
        ...selectedColumns,
        [column]: nextVisible,
      })
        .filter(([, visible]) => !visible)
        .map(([key]) => key);
      localStorage.setItem(columnsStorageKey, JSON.stringify(hiddenColumns));
      setSelectedColumns((prev: any) => ({
        ...prev,
        [column]: nextVisible,
      }));
    }
  };

  const handleTypeSearch = (option: { key: string; type: number }) => {
    currentPageRef.current = 1;
    setType(option.type);
    setTypeSearch(option.key);
    setSelectedSearch(option.key);
  };

  const handleAdvancedSearch = (event: any) => {
    const newValue = event.target.value;
    currentPageRef.current = 1;
    setSearch(newValue);
  };

  const handleSelectChange = async (event: any) => {
    const newValue = event.target.value;
    setLimit(newValue);
    const commentsFormServer = await fetchUser(
      currentPageRef.current,
      newValue,
    );
    setListUser(commentsFormServer);
  };

  const fetchUserData = async (
    currentPage: number,
    limit: number,
    sortType: string,
    sortDirection: string,
    search?: string,
    type?: number,
  ) => {
    try {
      setLoading(true);

      const totalRes = await fetch(
        `${backendUrl}/api/users/total?page=${currentPage}&limit=${limit}&search=${search}&type=${type}`,
        { mode: "cors", credentials: "include" },
      );
      const totalData = await totalRes.json();
      const total = totalData[0].total;
      setTotal(total);

      const calculatedPageCount = Math.ceil(total / limit);
      setPageCount(calculatedPageCount);

      const res = await fetch(
        `${backendUrl}/api/users?page=${currentPage}&limit=${limit}&sortColumn=${sortType}&sortOrder=${sortDirection}&search=${search}&type=${type}`,
        { mode: "cors", credentials: "include" },
      );

      if (!res.ok) {
        throw new Error(
          `Erreur lors de la récupération des utilisateurs. Statut : ${res.status}`,
        );
      }

      const data = await res.json();
      setListUser(data);
      setList(data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserData(
      currentPageRef.current,
      limit,
      sortType,
      sortDirection,
      search,
      type,
    );
  }, [user_id, limit, sortType, sortDirection, search, type]);

  const fetchUser = async (currentPage: number, limit: any) => {
    const res = await fetch(
      `${backendUrl}/api/users?page=${currentPage}&limit=${limit}&sortColumn=${sortType}&sortOrder=${sortDirection}&search=${search}&type=${type}`,
      { mode: "cors", credentials: "include" },
    );
    const data = await res.json();
    return data;
  };

  const handlePageClick = async (data: { selected: number }) => {
    currentPageRef.current = data.selected + 1;

    const commentsFormServer = await fetchUser(currentPageRef.current, limit);
    setListUser(commentsFormServer);

    fetchUserData(
      currentPageRef.current,
      limit,
      sortType,
      sortDirection,
      search,
      type,
    );
  };

  const handleDeleteClick = async (user_id: string) => {
    setSelecteduser_id(user_id);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const refreshUserData = async () => {
    await fetchUserData(
      currentPageRef.current,
      limit,
      sortType,
      sortDirection,
      search,
      type,
    );
  };

  const handleConfirmDelete = async () => {
    try {
      const loggedInuser_id = localStorage.getItem("userid");

      const response = await fetch(
        `${backendUrl}/api/softDeleteUser/${selecteduser_id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify({ loggedInuser_id: loggedInuser_id }),
        },
      );

      if (!response.ok) {
        throw new Error(
          `Erreur lors de la suppression logique. Statut : ${response.status}`,
        );
      }

      await response.json();

      toast.success(translate("User Deleted successfully !"), {
        position: "bottom-right",
        autoClose: 2400,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });

      setShowModal(false);
      await refreshUserData();
      await fetchDeletedUsersCount();

      if (showDeletedUsersModal) {
        await fetchDeletedUsers();
      }
    } catch (error) {
      console.error(error);
    }

    try {
      const timestamp = new Date(Date.now() + 60 * 60 * 1000)
        .toISOString()
        .slice(0, 19)
        .replace("T", " ");
      const details = `Delete user: ${selecteduser_id}`;

      await fetch(`${backendUrl}/api/log-user-action/${user_id}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          action: "Delete",
          page: "Users",
          operation: "supprimer",
          timestamp,
          details,
        }),
      });
    } catch (error) {
      console.error("Error logging user action:", error);
    }
  };

  const fetchDeletedUsers = async () => {
    try {
      const response = await fetch(
        `${backendUrl}/api/deleted-users/${user_id}`,
        { mode: "cors", credentials: "include" },
      );

      if (!response.ok) {
        throw new Error(
          `Error fetching deleted users. Status: ${response.status}`,
        );
      }

      const data = await response.json();
      setDeletedUsers(data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleShowDeletedUsersModal = async () => {
    await fetchDeletedUsers();
    await fetchDeletedUsersCount();
    setShowDeletedUsersModal(true);
  };

  const handleCloseDeletedUsersModal = () => {
    setShowDeletedUsersModal(false);
  };

  const fetchDeletedUsersCount = async () => {
    try {
      const response = await fetch(
        `${backendUrl}/api/deleted-users-count/${user_id}`,
        { mode: "cors", credentials: "include" },
      );

      if (!response.ok) {
        throw new Error(
          `Error fetching deleted users count. Status: ${response.status}`,
        );
      }

      const data = await response.json();
      setDeletedUsersCount(data.count);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchDeletedUsersCount();
  }, [user_id]);

  const handleRestore = async (id_user: number) => {
    try {
      const response = await fetch(`${backendUrl}/api/restoreUser/${id_user}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      });

      if (!response.ok) {
        throw new Error(`Error restoring the user. Status: ${response.status}`);
      }

      toast.success(translate("User Restored successfully !"), {
        position: "bottom-right",
        autoClose: 2400,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });

      await fetchDeletedUsers();
      await fetchDeletedUsersCount();
      await refreshUserData();
    } catch (error) {
      console.error(error);
    }
  };

  const handleConfirmActivation = async () => {
    if (!userToActivate) return;

    try {
      setActivatingUser(true);
      const response = await fetch(
        `${backendUrl}/api/users/${userToActivate.id_user}/activate`,
        {
          method: "PUT",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
        },
      );

      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        throw new Error(data?.message || "Erreur pendant la validation du compte");
      }

      toast.success(translate("Account validated successfully"), {
        position: "bottom-right",
        autoClose: 2400,
        theme: "light",
      });
      setUserToActivate(null);
      await refreshUserData();
    } catch (error: any) {
      toast.error(error?.message || translate("Account validation failed"), {
        position: "bottom-right",
        autoClose: 3000,
        theme: "light",
      });
    } finally {
      setActivatingUser(false);
    }
  };

  const handleHardDelete = (id_user: number) => {
    setHardDeleteUserId(id_user);
    setShowHardDeleteModal(true);
  };

  const handleConfirmHardDelete = async () => {
    if (!hardDeleteUserId) return;

    try {
      const response = await fetch(
        `${backendUrl}/api/hardDeleteUser/${hardDeleteUserId}`,
        { method: "DELETE", credentials: "include" },
      );

      if (!response.ok) throw new Error(`Status: ${response.status}`);

      toast.success(translate("User permanently deleted!"), {
        position: "bottom-right",
        autoClose: 2400,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
        transition: Bounce,
      });

      await fetchDeletedUsers();
      await fetchDeletedUsersCount();
    } catch (error) {
      console.error(error);
    } finally {
      setShowHardDeleteModal(false);
      setHardDeleteUserId(null);
    }
  };

  const handleSort = async (type: "id_user") => {
    let sortOrder: "asc" | "desc" = "asc";

    if (type === sortType) {
      sortOrder = sortDirection === "asc" ? "desc" : "asc";
    }

    setSortType(type);
    setSortDirection(sortOrder);
  };

  const handleSelection = (user_id: number) => {
    const isSelected = selectedUsers.includes(user_id);

    if (isSelected) {
      setSelectedUsers(selectedUsers.filter((id) => id !== user_id));
    } else {
      setSelectedUsers([...selectedUsers, user_id]);
    }
  };

  const handleSelectAllCheckboxChange = () => {
    if (selectAll) {
      setSelectedUsers([]);
    } else {
      const alluser_ids = displayedUsers.map((item) => item.id_user);
      setSelectedUsers(alluser_ids);
    }

    setSelectAll(!selectAll);
  };

  const normalizeSearchValue = (value: unknown) =>
    String(value ?? "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");

  const matchesUserDetails = (user: User, term: string) => {
    const normalizedTerm = normalizeSearchValue(term.trim());
    if (!normalizedTerm || typeSearch !== "details") return true;

    return [
      user.id_user,
      user.nom_user,
      user.prenom_user,
      user.username_user,
      user.company,
      user.email_user,
      user.phone_user,
      user.wilaya,
      user.role_name,
      user.date_creation_user
        ? new Date(user.date_creation_user).toLocaleDateString()
        : "",
    ].some((value) => normalizeSearchValue(value).includes(normalizedTerm));
  };

  const displayedUsers = list_user.filter((user) =>
    matchesUserDetails(user, search),
  );

  const visibleColumnCount =
    2 + Object.values(selectedColumns).filter(Boolean).length;

  const formatPhoneNumber = (phone?: string) => {
    const raw = String(phone || "").trim();
    if (!raw) return "-";

    const cleaned = raw.replace(/[^\d+]/g, "");
    const hasPlus = cleaned.startsWith("+");
    const digits = cleaned.replace(/\D/g, "");
    const groups = digits.match(/.{1,2}/g) || [];

    return `${hasPlus ? "+" : ""}${groups.join(" ")}`;
  };

  const copyPhoneNumber = async (phone?: string) => {
    const value = String(phone || "").trim();
    if (!value) return;

    try {
      await navigator.clipboard.writeText(value);
      toast.success(translate("Phone copied"), {
        position: "bottom-right",
        autoClose: 1500,
        hideProgressBar: true,
        theme: "light",
      });
    } catch (error) {
      console.error("Error copying phone number:", error);
    }
  };

  const generateExcel = async () => {
    try {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Users");

      const headers = [
        "ID",
        "Nom",
        "Nom d'utilisateur",
        "Email",
        "Téléphone",
        "Région",
        "Date d'inscription",
      ];
      worksheet.addRow(headers);

      list_user.forEach((user) => {
        if (selectedUsers.includes(user.id_user)) {
          worksheet.addRow([
            user.id_user,
            `${user.nom_user} ${user.prenom_user}`,
            user.username_user,
            user.email_user,
            user.phone_user,
            user.wilaya,
            new Date(user.date_creation_user).toLocaleDateString(),
          ]);
        }
      });

      worksheet.columns.forEach((column) => {
        column.width = Math.max(column.width ?? 0, 25);
      });

      const buffer = await workbook.xlsx.writeBuffer();
      const currentDate = new Date();
      const dateString = currentDate.toISOString().split("T")[0];
      const timeString = currentDate
        .toTimeString()
        .split(" ")[0]
        .replace(/:/g, "-");
      const fileName = `Liste_users_${dateString}_${timeString}.xlsx`;

      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Erreur lors de la génération du fichier Excel :", error);
    }

    setSelectedUsers([]);
    setSelectAll(false);
  };

  const handleUserSelection = async (
    id_role: number,
    id_user: number,
    username: string,
  ) => {
    try {
      const response = await axios.post(
        `${backendUrl}/api/switch-user`,
        { id_user },
        { withCredentials: true },
      );

      console.log("switch-user response:", response.data);

      localStorage.setItem("userid", id_user.toString());
      localStorage.setItem("user_id", id_user.toString());
      localStorage.setItem("username", username);

      await login();

      const profileRouteByRole: Record<number, string> = {
        2: `/profileSupplier/${id_user}`,
        3: `/oem-profile/${id_user}`,
        4: `/expert-profile/${id_user}`,
      };

      window.location.href = profileRouteByRole[id_role] || "/profile";
    } catch (error: any) {
      console.error("Erreur lors du changement d'utilisateur :", error);
      console.error("Response:", error?.response?.data);
      alert("Impossible de changer d'utilisateur.");
    }
  };

  const getRoleBadge = (role: string) => {
    const value = (role || "").toLowerCase();

    const config = {
      admin: {
        label: translate("Admin"),
        bg: "linear-gradient(135deg, #fff1f2 0%, #ffe4e6 100%)",
        color: "#b91c1c",
        border: "#fda4af",
        dot: "#ef4444",
        shadow: "0 4px 14px rgba(239, 68, 68, 0.14)",
      },
      supplier: {
        label: translate("Supplier"),
        bg: "linear-gradient(135deg, #ecfdf3 0%, #d1fae5 100%)",
        color: "#166534",
        border: "#86efac",
        dot: "#22c55e",
        shadow: "0 4px 14px rgba(34, 197, 94, 0.16)",
      },
      oem: {
        label: translate("OEM"),
        bg: "linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%)",
        color: "#b45309",
        border: "#fcd34d",
        dot: "#f59e0b",
        shadow: "0 4px 14px rgba(245, 158, 11, 0.14)",
      },
      expert: {
        label: translate("Expert"),
        bg: "linear-gradient(135deg, #eef2ff 0%, #e0e7ff 100%)",
        color: "#3730a3",
        border: "#a5b4fc",
        dot: "#6366f1",
        shadow: "0 4px 14px rgba(99, 102, 241, 0.14)",
      },
    };

    const current = config[value as keyof typeof config] || config.oem;

    return (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "8px",
          padding: "6px 14px",
          borderRadius: "999px",
          background: current.bg,
          color: current.color,
          border: `1px solid ${current.border}`,
          boxShadow: current.shadow,
          fontSize: "12px",
          fontWeight: 600,
        }}
      >
        <span
          style={{
            width: 8,
            height: 8,
            borderRadius: "50%",
            background: current.dot,
          }}
        />
        {current.label}
      </span>
    );
  };

  const actionButtonStyle = {
    width: "40px",
    height: "40px",
    padding: 0,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    lineHeight: 1,
    borderRadius: "50%",
    border: "none",
    boxShadow: "0 6px 16px rgba(15, 23, 42, 0.08)",
    transition: "all 0.2s ease",
  } as const;

  const getActionButtonStyle = (
    bg: string,
    color: string = "#ffffff",
    border?: string,
  ) => ({
    ...actionButtonStyle,
    backgroundColor: bg,
    color,
    border: border ? `1px solid ${border}` : "none",
  });

  return (
    <>
      <div>
        <div className="row">
          <div className="col-md-6">
            <h4>
              <i
                className="las la-user"
                data-rel="bootstrap-tooltip"
                title="Users"
              ></i>
              {translate("Users")} ( {total} )
            </h4>
          </div>

          <div className="col-md-6">
            <div className="text-right embed-responsive">
              <div
                id="DataTables_Table_0_filter"
                className="dataTables_filter"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  gap: "10px",
                  flexWrap: "wrap",
                }}
              >
                <Link
                  to="/User"
                  className="btn"
                  style={{
                    backgroundColor: "#facc15",
                    border: "1px solid #facc15",
                    color: "#111827",
                    fontWeight: 400,
                    borderRadius: "8px",
                    padding: "8px 14px",
                    textDecoration: "none",
                    display: "inline-flex",
                    alignItems: "center",
                  }}
                >
                  <i className="las la-plus mr-2"></i>
                  {translate("New Users")}
                </Link>

                <Button
                  className="btn"
                  style={{
                    backgroundColor: "#facc15",
                    border: "1px solid #facc15",
                    color: "#111827",
                    fontWeight: 400,
                    borderRadius: "8px",
                    padding: "8px 14px",
                    display: "inline-flex",
                    alignItems: "center",
                  }}
                  onClick={generateExcel}
                >
                  <i className="las la-file-excel mr-2"></i>
                  {translate("Download Excel")}
                </Button>

                <Button
                  className="btn"
                  style={{
                    backgroundColor: "#ef4444",
                    border: "1px solid #ef4444",
                    color: "#ffffff",
                    fontWeight: 400,
                    borderRadius: "8px",
                    padding: "8px 14px",
                    display: "inline-flex",
                    alignItems: "center",
                  }}
                  onClick={handleShowDeletedUsersModal}
                >
                  <i className="las la-trash-alt mr-2"></i>
                  {translate("Deleted Users")} ({deletedUsersCount})
                </Button>
              </div>
            </div>
          </div>
        </div>

        <div className="row" style={{ marginTop: "15px" }}>
          <div className="col-md-6">
            <div className="input-group">
              <Dropdown>
                <Dropdown.Toggle
                  variant="outline-secondary"
                  aria-label={translate("Search criterion")}
                  style={{ minWidth: "170px", height: "38px" }}
                >
                  {translate(selectedSearch)}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  {searchOptions.map((option) => (
                    <Dropdown.Item
                      as="button"
                      key={option.key}
                      active={selectedSearch === option.key}
                      onClick={() => handleTypeSearch(option)}
                    >
                      {translate(option.key)}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>

              <input
                type="text"
                className="form-control"
                placeholder={`${translate("search_by")} ${translate(typeSearch)}`}
                value={search}
                onChange={handleAdvancedSearch}
              />

              <Button
                variant="secondary"
                style={{ height: "38px" }}
                onClick={() => {
                  currentPageRef.current = 1;
                  setSearch("");
                }}
              >
                ✕
              </Button>
            </div>
          </div>

          <div className="col-md-6">
            <div
              className="dataTables_length text-right embed-responsive d-flex justify-content-end align-items-center"
              id="DataTables_Table_0_length"
              style={{ gap: "10px", flexWrap: "wrap" }}
            >
              <label>
                {translate("Show")}
                <select
                  name="DataTables_Table_0_length"
                  aria-controls="DataTables_Table_0"
                  className="custom-select custom-select-sm form-control form-control-sm mr-2 ml-2"
                  style={{ width: "66px" }}
                  onChange={handleSelectChange}
                >
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="200">200</option>
                  <option value="500">500</option>
                </select>
                {translate("entries")}
              </label>

              <Dropdown>
                <Dropdown.Toggle
                  variant=""
                  id="users-columns-dropdown"
                  title={translate("Display columns")}
                >
                  <i className="las la-eye"></i>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  {[
                    ["id_user", "id"],
                    ["name", "name"],
                    ["username_user", "User name"],
                    ["company", "Company"],
                    ["email_user", "Email"],
                    ["phone_user", "Phone"],
                    ["wilaya", "region"],
                    ["date_creation_user", "Registration date"],
                    ["role_name", "Role"],
                  ].map(([key, label]) => (
                    <Dropdown.Item as="button" key={key}>
                      <input
                        type="checkbox"
                        checked={(selectedColumns as any)[key]}
                        onChange={() => handleColumnChange(key)}
                      />
                      <span className="ml-2">{translate(label)}</span>
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="table-responsive">
          <Table className="dataTable table">
            <thead className="bg-white text-uppercase">
              <tr className="ligth ligth-data">
                <th>
                  <div className="checkbox d-inline-block">
                    <input
                      type="checkbox"
                      className="checkbox-input"
                      id="selectAllCheckbox"
                      onChange={handleSelectAllCheckboxChange}
                      checked={selectAll}
                    />
                    <label htmlFor="selectAllCheckbox" className="mb-0"></label>
                  </div>
                </th>
                {selectedColumns.id_user && (
                <th style={{ width: "120px", cursor: "pointer" }}>
                  <span onClick={() => handleSort("id_user")}>
                    {translate("Id")}
                    {sortType === "id_user" && sortDirection === "asc" && " ▲"}
                    {sortType === "id_user" && sortDirection === "desc" && " ▼"}
                  </span>
                </th>
                )}
                {selectedColumns.name && <th>{translate("name")}</th>}
                {selectedColumns.username_user && <th>{translate("User name")}</th>}
                {selectedColumns.company && <th>{translate("Company")}</th>}
                {selectedColumns.email_user && <th>{translate("Email")}</th>}
                {selectedColumns.phone_user && <th>{translate("Phone")}</th>}
                {selectedColumns.wilaya && <th>{translate("region")}</th>}
                {selectedColumns.date_creation_user && <th>{translate("Registration date")}</th>}
                {selectedColumns.role_name && <th>{translate("Role")}</th>}
                <th>{translate("Actions")}</th>
              </tr>
            </thead>

            {loading ? (
              <tr>
                <td colSpan={visibleColumnCount}>
                  <div className="text-center">
                    <PropagateLoader
                      color={"#123abc"}
                      loading={loading}
                      size={20}
                    />
                  </div>
                </td>
              </tr>
            ) : (
              <>
                {Array.isArray(displayedUsers) &&
                  displayedUsers.length !== 0 &&
                  displayedUsers.map((item) => {
                    return (
                      <tbody key={item["id_user"]} className="ligth-body">
                        <tr className={String(item["id_user"])}>
                          <td>
                            <div className="checkbox d-inline-block">
                              <input
                                type="checkbox"
                                className="checkbox-input"
                                id={`checkbox-${item["id_user"]}`}
                                onChange={() =>
                                  handleSelection(item["id_user"])
                                }
                                checked={selectedUsers.includes(
                                  item["id_user"],
                                )}
                              />
                              <label
                                htmlFor={`checkbox-${item["id_user"]}`}
                                className="mb-0"
                              ></label>
                            </div>
                          </td>

                          {selectedColumns.id_user && <td>{item["id_user"]}</td>}
                          {selectedColumns.name && (
                            <td>
                              {item["nom_user"]} {item["prenom_user"]}
                            </td>
                          )}
                          {selectedColumns.username_user && (
                            <td>{item["username_user"]}</td>
                          )}
                          {selectedColumns.company && <td>{item["company"]}</td>}
                          {selectedColumns.email_user && (
                            <td id="5">{item["email_user"]}</td>
                          )}
                          {selectedColumns.phone_user && (
                            <td>
                              {item["phone_user"] ? (
                                <button
                                  type="button"
                                  className="btn btn-link p-0 user-phone-copy"
                                  title={translate("Copy phone")}
                                  onClick={() =>
                                    copyPhoneNumber(item["phone_user"])
                                  }
                                >
                                  <i className="las la-phone mr-1"></i>
                                  <span>{formatPhoneNumber(item["phone_user"])}</span>
                                </button>
                              ) : (
                                "-"
                              )}
                            </td>
                          )}
                          {selectedColumns.wilaya && <td>{item["wilaya"]}</td>}
                          {selectedColumns.date_creation_user && (
                            <td>
                              {new Date(
                                item["date_creation_user"],
                              ).toLocaleDateString()}
                            </td>
                          )}
                          {selectedColumns.role_name && (
                            <td>{getRoleBadge(item["role_name"])}</td>
                          )}
                          <td>
                            <div
                              className="d-flex align-items-center justify-content-center"
                              style={{ gap: "10px", flexWrap: "nowrap" }}
                            >
                              {user_id === "1" && (
                                <Fragment>
                                  {Number(item["draft"]) !== 0 && (
                                    <button
                                      type="button"
                                      className="btn btn-sm"
                                      style={getActionButtonStyle("#16a34a")}
                                      title={translate("Validate account")}
                                      aria-label={translate("Validate account")}
                                      onClick={() => setUserToActivate(item)}
                                    >
                                      <i
                                        className="fas fa-user-check"
                                        style={{ fontSize: "13px" }}
                                      ></i>
                                    </button>
                                  )}

                                  <button
                                    type="button"
                                    className="btn btn-sm"
                                    style={getActionButtonStyle("#020817")}
                                    title={translate("Go")}
                                    onClick={() =>
                                      handleUserSelection(
                                        item["id_role"],
                                        item["id_user"],
                                        item["username_user"],
                                      )
                                    }
                                  >
                                    <i
                                      className="fas fa-user"
                                      style={{ fontSize: "13px" }}
                                    ></i>
                                  </button>

                                  <Link
                                    to={`/notification-center/${item["id_user"]}`}
                                    className="btn btn-sm"
                                    style={{
                                      ...getActionButtonStyle("#f59e0b"),
                                      textDecoration: "none",
                                    }}
                                    title={translate("Send notification")}
                                  >
                                    <i
                                      className="fas fa-bell"
                                      style={{ fontSize: "13px" }}
                                    ></i>
                                  </Link>
                                </Fragment>
                              )}

                              <Link
                                to={`/User/${item["id_user"]}`}
                                className="btn btn-sm"
                                style={{
                                  ...getActionButtonStyle(
                                    "#facc15",
                                    "#111827",
                                    "#facc15",
                                  ),
                                  textDecoration: "none",
                                }}
                                title={translate("Edit")}
                              >
                                <i
                                  className="fas fa-edit"
                                  style={{ fontSize: "13px" }}
                                ></i>
                              </Link>

                              <button
                                type="button"
                                className="btn btn-sm"
                                style={getActionButtonStyle("#ef4444")}
                                title={translate("Delete")}
                                onClick={() =>
                                  handleDeleteClick(String(item["id_user"]))
                                }
                              >
                                <i
                                  className="fas fa-trash"
                                  style={{ fontSize: "13px" }}
                                ></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    );
                  })}
              </>
            )}
          </Table>
        </div>

      
      </div>

        <div className="row">
          <div className="col-md-6 d-flex align-items-center">
            <span>
              {translate("Displaying")} {displayedUsers.length} {translate("out of")}{" "}
              {total}
            </span>
          </div>

          <div className="col-md-6 d-flex justify-content-end">
            <ReactPaginate
              previousLabel={translate("previous")}
              nextLabel={translate("next")}
              breakLabel={"..."}
              pageCount={pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={3}
              onPageChange={handlePageClick}
              containerClassName={"pagination justify-content-center"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              previousClassName={"page-item"}
              previousLinkClassName={"page-link"}
              nextClassName={"page-item"}
              nextLinkClassName={"page-link"}
              breakClassName={"page-item"}
              breakLinkClassName={"page-link"}
              activeClassName={"active"}
            />
          </div>
        </div>

      <Modal
        show={Boolean(userToActivate)}
        onHide={() => !activatingUser && setUserToActivate(null)}
        centered
      >
        <Modal.Header closeButton={!activatingUser}>
          <Modal.Title>{translate("Validate user account")}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center" style={{ padding: "28px 20px" }}>
          <div
            className="d-inline-flex align-items-center justify-content-center mb-3"
            style={{
              width: 52,
              height: 52,
              borderRadius: "50%",
              backgroundColor: "#ecfdf3",
              color: "#16a34a",
              fontSize: 22,
            }}
          >
            <i className="fas fa-user-check" aria-hidden="true"></i>
          </div>
          <p className="mb-0">
            {translate("Do you want to validate this account?")} {" "}
            <strong>{userToActivate?.username_user}</strong>
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="light"
            onClick={() => setUserToActivate(null)}
            disabled={activatingUser}
          >
            {translate("Cancel")}
          </Button>
          <Button
            variant="success"
            onClick={handleConfirmActivation}
            disabled={activatingUser}
          >
            {activatingUser
              ? translate("Validation in progress")
              : translate("Validate account")}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showModal}
        onHide={handleCloseModal}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title
            style={{
              fontSize: "18px",
              fontWeight: 500,
              color: "#1f2937",
            }}
          >
            {translate("Confirmation of deletion.")}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body
          className="text-center"
          style={{
            fontSize: "16px",
            color: "#374151",
            padding: "28px 20px",
          }}
        >
          {translate("Do you really want to delete this user?")}
        </Modal.Body>

        <Modal.Footer
          style={{
            borderTop: "1px solid #e5e7eb",
            padding: "16px 20px",
            gap: "10px",
          }}
        >
          <Button
            onClick={handleCloseModal}
            style={{
              backgroundColor: "#ffffff",
              border: "1px solid #cbd5e1",
              color: "#334155",
              borderRadius: "10px",
              padding: "8px 18px",
              fontWeight: 500,
              minWidth: "110px",
              boxShadow: "0 4px 12px rgba(15, 23, 42, 0.04)",
            }}
          >
            {translate("Cancel")}
          </Button>

          <Button
            onClick={handleConfirmDelete}
            style={{
              backgroundColor: "#ef4444",
              border: "1px solid #ef4444",
              color: "#ffffff",
              borderRadius: "10px",
              padding: "8px 18px",
              fontWeight: 500,
              minWidth: "110px",
              boxShadow: "0 6px 16px rgba(239, 68, 68, 0.18)",
            }}
          >
            {translate("Delete")}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showDeletedUsersModal}
        onHide={handleCloseDeletedUsersModal}
        dialogClassName="modal-lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-center">
            {translate("Deleted Users")}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {deletedUsers.length === 0 ? (
            <div className="text-center py-4 text-muted">
              {translate("No deleted users found")}
            </div>
          ) : (
            <table className="table align-middle">
              <thead>
                <tr>
                  <th>{translate("ID")}</th>
                  <th>{translate("Username")}</th>
                  <th className="text-right">{translate("Actions")}</th>
                </tr>
              </thead>
              <tbody>
                {deletedUsers.map((user) => (
                  <tr key={user.id_user}>
                    <td>{user.id_user}</td>
                    <td>{user.name}</td>
                    <td
                      className="text-right"
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "10px",
                      }}
                    >
                      <Button
                        style={{
                          backgroundColor: "#22c55e",
                          border: "1px solid #22c55e",
                          color: "#ffffff",
                          borderRadius: "8px",
                          padding: "6px 12px",
                          fontWeight: 400,
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "6px",
                        }}
                        onClick={() => handleRestore(user.id_user)}
                      >
                        <i className="las la-undo"></i>
                        {translate("Restore")}
                      </Button>

                      <Button
                        style={{
                          backgroundColor: "#ef4444",
                          border: "1px solid #ef4444",
                          color: "#ffffff",
                          borderRadius: "8px",
                          padding: "6px 12px",
                          fontWeight: 400,
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "6px",
                        }}
                        onClick={() => handleHardDelete(user.id_user)}
                      >
                        <i className="las la-trash"></i>
                        {translate("Delete Permanently")}
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button
            style={{
              backgroundColor: "#64748b",
              border: "1px solid #64748b",
              color: "#ffffff",
              borderRadius: "8px",
              padding: "6px 14px",
              fontWeight: 400,
            }}
            onClick={handleCloseDeletedUsersModal}
          >
            {translate("Close")}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showHardDeleteModal}
        onHide={() => setShowHardDeleteModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{translate("Permanent Deletion")}</Modal.Title>
        </Modal.Header>

        <Modal.Body className="text-center">
          {translate(
            "Are you sure you want to permanently delete this user? This action cannot be undone.",
          )}
        </Modal.Body>

        <Modal.Footer
          style={{
            borderTop: "1px solid #e5e7eb",
            padding: "16px 20px",
            gap: "10px",
          }}
        >
          <Button
            onClick={() => setShowHardDeleteModal(false)}
            style={{
              backgroundColor: "#ffffff",
              border: "1px solid #cbd5e1",
              color: "#334155",
              borderRadius: "10px",
              padding: "8px 18px",
              fontWeight: 500,
              minWidth: "120px",
              boxShadow: "0 4px 12px rgba(15, 23, 42, 0.04)",
            }}
          >
            {translate("Cancel")}
          </Button>

          <Button
            onClick={handleConfirmHardDelete}
            style={{
              backgroundColor: "#dc2626",
              border: "1px solid #dc2626",
              color: "#ffffff",
              borderRadius: "10px",
              padding: "8px 18px",
              fontWeight: 500,
              minWidth: "170px",
              boxShadow: "0 6px 16px rgba(220, 38, 38, 0.2)",
            }}
          >
            <i className="las la-trash mr-1"></i>
            {translate("Delete Permanently")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
